import { Injectable } from '@angular/core';

import {
  PageBreadcrumbResolver, PageDescriptionResolver, PageHeadingResolver, PageImageResolver,
  PageRobotsResolver, PageTitleResolver,
  Product,
  ProductPageMetaResolver,
} from "@spartacus/core";
import {Observable, of, switchMap} from "rxjs";
import {isPortugal} from "../../utils/check-environment";


/**
 * Resolves the page data for the Product Detail Page
 * based on the `PageType.PRODUCT_PAGE`.
 *
 * The page title, heading, description, breadcrumbs and
 * first GALLERY image are resolved if available in the data.
 */
@Injectable({
  providedIn: 'root',
})
export class GonvarriProductPageMetaResolver
  extends ProductPageMetaResolver
  implements
    PageHeadingResolver,
    PageTitleResolver,
    PageDescriptionResolver,
    PageBreadcrumbResolver,
    PageImageResolver,
    PageRobotsResolver
{

  override resolveHeading(): Observable<string> {
    if(isPortugal()){
      return this.product$.pipe(
        switchMap((p: Product) =>
          of(p.name!)
        )
      );
    }
    return super.resolveHeading()
  }
}
